import request from '~/utils/request';

import {
  SET_BRANDING_ASSETS_DATA,
  SET_BRANDING_ASSETS_LOADER,
  CREATE_BRANDING_ASSET,
  UPDATE_BRANDING_ASSET,
  DELETE_BRANDING_ASSET,
} from './action-types';

// Utils
import { DEFAULT_PAGINATION } from '~/utils/constants';

// Fetch all branding assets
const fetchBrandingAssets = (payload) => async (dispatch) => {
  try {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: true });

    let url = '/branding-assets';

    let queryPayload = {
      page: payload?.pagination?.page ? payload.pagination.page : DEFAULT_PAGINATION.page,
      pageSize: payload?.pagination?.pageSize
        ? payload.pagination.pageSize
        : DEFAULT_PAGINATION.pageSize,
    };

    if (payload?.search?.length) {
      queryPayload.search = payload.search;
    }

    const response = await request.get(url, queryPayload);

    if (response.status === 200) {
      const brandingAssets = {
        rows: response.data.data.rows || [],
        count: response.data.data.count || 0,
        totalRecordsInDB: response.data.data.totalRecordsInDB || 0,
        to: response.data.data.to || null,
        from: response.data.data.from || null,
        currentPage: response.data.data.currentPage || 1,
        lastPage: response.data.data.lastPage || 1,
        perPage: response.data.data.perPage || DEFAULT_PAGINATION.pageSize,
      };
      dispatch({ type: SET_BRANDING_ASSETS_DATA, payload: brandingAssets });
    }

    return response;
  } catch (error) {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    // Set empty data on error to prevent filter issues
    dispatch({ type: SET_BRANDING_ASSETS_DATA, payload: { rows: [], count: 0 } });
    return error;
  } finally {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
  }
};

// Create a new branding asset (upload image as formData)
const createBrandingAsset = (formData) => async (dispatch) => {
  try {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: true });
    const response = await request.post('branding-assets', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    dispatch({ type: CREATE_BRANDING_ASSET, payload: response.data.data });
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return response;
  } catch (error) {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return error;
  }
};

// Update an existing branding asset (only name)
const updateBrandingAsset = (id, name) => async (dispatch) => {
  try {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: true });
    const response = await request.patch(`branding-assets/${id}`, { name });
    dispatch({ type: UPDATE_BRANDING_ASSET, payload: { id, data: response.data.data } });
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return response;
  } catch (error) {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return error;
  }
};

// Delete a branding asset
const deleteBrandingAsset = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: true });
    const response = await request.delete(`branding-assets/${id}`);
    dispatch({ type: DELETE_BRANDING_ASSET, payload: id });
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return response;
  } catch (error) {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return error;
  }
};

// Get a single branding asset by ID
const fetchBrandingAssetById = (id) => async (dispatch) => {
  try {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: true });
    const response = await request.get(`branding-assets/${id}`);
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return response;
  } catch (error) {
    dispatch({ type: SET_BRANDING_ASSETS_LOADER, payload: false });
    return error;
  }
};

// Upload branding asset file (alias for createBrandingAsset)
const uploadBrandingAsset = (formData) => async (dispatch) => {
  return dispatch(createBrandingAsset(formData));
};

export {
  fetchBrandingAssets,
  createBrandingAsset,
  updateBrandingAsset,
  deleteBrandingAsset,
  fetchBrandingAssetById,
  uploadBrandingAsset,
};
